@if (isOpen) {
  <div
    class="fixed inset-0 z-modal bg-black/50 flex items-center justify-center p-4"
    (click)="cancelar()"
  >
    <div
      class="w-full max-w-5xl h-[85vh] flex flex-col rounded-2xl bg-white dark:bg-gray-900 shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div>
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Elegir plantilla
          </h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Se listan tus plantillas activas. El HTML se copiará al cuerpo del correo como snapshot.
          </p>
        </div>
        <button type="button" (click)="cancelar()"
          class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Body: dos columnas (lista + preview) -->
      <div class="flex-1 min-h-0 grid grid-cols-1 md:grid-cols-2 gap-0 overflow-hidden">
        <!-- Lista -->
        <div class="flex flex-col min-h-0 border-r border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="p-4 space-y-2 border-b border-gray-100 dark:border-gray-800">
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (ngModelChange)="aplicarFiltros()"
              placeholder="Buscar por nombre o asunto..."
              class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
            />
            <div>
              <select
                [(ngModel)]="filtroCategoryId"
                (ngModelChange)="aplicarFiltros()"
                class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
              >
                <option value="">Todas las categorías</option>
                @for (c of categories; track trackCatById($index, c)) {
                  <option [value]="c.idCategory">{{ c.name }}</option>
                }
              </select>
            </div>
          </div>

          <div class="flex-1 overflow-y-auto p-2">
            @if (loading) {
              <div class="flex justify-center py-8">
                <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
              </div>
            } @else if (error) {
              <p class="text-center text-sm text-error-600 py-8">{{ error }}</p>
            } @else if (filtered.length === 0) {
              <p class="text-center text-sm text-gray-500 py-8">
                @if (templates.length === 0) {
                  No tenés plantillas creadas todavía.
                } @else {
                  No hay plantillas que coincidan con los filtros.
                }
              </p>
            } @else {
              <ul class="space-y-1.5">
                @for (t of filtered; track trackById($index, t)) {
                  <li>
                    <button type="button" (click)="seleccionar(t)"
                      class="w-full text-left rounded-lg border px-3 py-2 transition-colors"
                      [class.border-brand-300]="selectedTpl?.idTemplate === t.idTemplate"
                      [class.bg-brand-50]="selectedTpl?.idTemplate === t.idTemplate"
                      [class.dark:bg-brand-500/10]="selectedTpl?.idTemplate === t.idTemplate"
                      [class.dark:border-brand-500/40]="selectedTpl?.idTemplate === t.idTemplate"
                      [class.border-gray-200]="selectedTpl?.idTemplate !== t.idTemplate"
                      [class.dark:border-gray-700]="selectedTpl?.idTemplate !== t.idTemplate"
                      [class.hover:bg-gray-50]="selectedTpl?.idTemplate !== t.idTemplate"
                      [class.dark:hover:bg-gray-800]="selectedTpl?.idTemplate !== t.idTemplate">
                      <div class="flex items-start justify-between gap-2">
                        <div class="min-w-0 flex-1">
                          <p class="text-sm font-medium text-gray-900 dark:text-white truncate">
                            {{ t.name }}
                          </p>
                          <p class="text-xs text-gray-500 dark:text-gray-400 truncate mt-0.5">
                            {{ t.subject || 'Sin asunto' }}
                          </p>
                          <p class="text-[10px] text-gray-400 mt-1 uppercase tracking-wide">
                            {{ categoryName(t.categoryId) }}
                          </p>
                        </div>
                        <div class="shrink-0 flex flex-col items-end gap-1">
                          <span [class]="'rounded-full px-2 py-0.5 text-[10px] font-medium ' + statusBadgeClass(t.status)">
                            {{ statusLabel(t.status) }}
                          </span>
                          <span [class]="'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium ' + visibilityBadgeClass(t)"
                            [title]="t.isPublic && !esMia(t) ? 'Plantilla pública de otro usuario' : ''">
                            @if (t.isPublic) {
                              <svg viewBox="0 0 20 20" fill="currentColor" class="h-2.5 w-2.5"><path d="M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 18a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.636.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z"/></svg>
                            } @else {
                              <svg viewBox="0 0 20 20" fill="currentColor" class="h-2.5 w-2.5"><path fill-rule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clip-rule="evenodd"/></svg>
                            }
                            {{ visibilityLabel(t) }}
                          </span>
                          @if (hasMergeTags(t)) {
                            <span title="Contiene merge tags"
                              class="rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-700 dark:bg-amber-900/20 dark:text-amber-300">
                              {{ '{{ }}' }}
                            </span>
                          }
                        </div>
                      </div>
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        </div>

        <!-- Preview -->
        <div class="flex flex-col min-h-0 overflow-hidden bg-gray-50 dark:bg-gray-900/50">
          @if (!selectedTpl) {
            <div class="flex-1 flex items-center justify-center p-8 text-center">
              <div>
                <div class="text-3xl mb-2">📨</div>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  Elegí una plantilla de la lista para ver su vista previa con datos de muestra.
                </p>
              </div>
            </div>
          } @else {
            <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
              <p class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">Asunto</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white truncate">
                {{ previewSubject || selectedTpl.subject || '—' }}
              </p>
            </div>
            <div class="flex-1 min-h-0 overflow-hidden">
              @if (previewLoading) {
                <div class="h-full flex items-center justify-center">
                  <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
                </div>
              } @else {
                <iframe
                  [srcdoc]="previewHtml || '<p style=\'padding:1rem;color:#9ca3af\'>(Sin contenido)</p>'"
                  sandbox
                  class="w-full h-full bg-white"
                ></iframe>
              }
            </div>
          }
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end gap-2 px-6 py-3 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
        <button type="button" (click)="cancelar()"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
          Cancelar
        </button>
        <button type="button" (click)="aplicar()" [disabled]="!selectedTpl || applying"
          class="px-4 py-2 text-sm rounded-lg bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
          {{ applying ? 'Cargando…' : 'Usar esta plantilla' }}
        </button>
      </div>
    </div>
  </div>
}
